<template>
  <v-snackbar
    v-model="installBar"
    vertical
    bottom
    style="z-index: 100001"
    dark
    :timeout="-1"
  >
    {{ $t('label.app_install_promo') }}
    <template #action>
      <v-btn
        class="mr-2"
        color="blue"
        elevation="0"
        small
        @click="installPrompt"
      >
        {{ $t('button.install_app') }}
      </v-btn>
      <v-btn
        text
        color="white"
        outlined
        elevation="0"
        small
        @click="dismissBar"
      >
        {{ $t('button.upgrade_later') }}
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue';

import storage from '@/services/local-storage';
import usePwaInstall from '@/composables/pwa-install';

//  PWA Promo Bar
const { isInstallable, installPrompt } = usePwaInstall();

const installBar = ref(false);

watch(isInstallable, () => {
  if (storage.getPwaBarDismissCount() >= 3) {
    console.log(`PWA Bar dismissed ${storage.getPwaBarDismissCount()} times, not showing again.`);
    installBar.value = false;
    return;
  }
  installBar.value = isInstallable.value;
});

const dismissBar = () => {
  installBar.value = false;
  storage.setPwaBarDismissCount(storage.getPwaBarDismissCount() + 1);
};

</script>
